import { Dialog, DialogContent } from '@mui/material';
import { useHistory } from 'react-router';
import BaseButton from './BaseButton';

const AgeApprovalModal: React.FC<{
  open: boolean;
  setOpen: React.Dispatch<boolean>;
}> = ({ open, setOpen }) => {
  const history = useHistory();
  return (
    <Dialog open={open} fullWidth onClose={() => setOpen(false)}>
      <DialogContent>
        <p>年齢認証を完了させてください。</p>
        <BaseButton
          onClick={() => {
            setOpen(false);
            history.push('/approvals/age');
          }}
          fill
          fullWidth
        >
          年齢認証へ
        </BaseButton>
        <BaseButton fullWidth sx={{ mt: 2 }} onClick={() => setOpen(false)}>
          キャンセル
        </BaseButton>
      </DialogContent>
    </Dialog>
  );
};

export default AgeApprovalModal;
